<template>
  <selector-layout>
    <div class="l-main-layout">
      <div class="l-main-layout__sidebar">
        <NavBackgrounds :category-ids="categoryIds" />
      </div>

      <div class="l-main-layout__main" :key="categoryId">

        <section v-if="backgrounds && backgrounds.entries">
          <div class="backgrounds">
            <div class="background" 
              v-for="background in backgrounds.entries" 
              :class="selected && selected.id == background.id ? 'selected' : selected ? 'not-selected' : ''" 
              :key="background.id">
              <img :src="background.thumbUrl"  @click="toggle(background)"/>
              <span class="background__name">{{background.name}}</span>
            </div>
          </div>

          <infinite-loading v-if="infiniteLoadReady" @infinite="infiniteHandler">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>
        </section>

        <div class="download-bar-container" :class="selected ? 'is-visible' : ''">
          <div class="download-bar">
            <div>
              <span class="items" v-if="selected">'{{ selected.name }}' selected</span>
            </div>
            <button class="button button--white" @click="download">Confirm</button>
          </div>
        </div>

      </div>

    </div>
  </selector-layout>
</template>

<script>
import NavBackgrounds from '../../components/NavBackgrounds';
import InfiniteLoading from 'vue-infinite-loading';
import { store } from '../../utils/store';
import BackgroundsQuery from '../../graphql/backgrounds.js'
import axios from 'axios';

export default {
  components: {
    NavBackgrounds,
    InfiniteLoading
  },

  props: ["categoryId"],

  data() {
    return {
      page: 1,
      pageSize: 24,
      sortField: 'name',
      sortOrder: 'asc',
      search: '',
      left: 0,
      top: 0,
      display: false,
      id: null,
      infiniteLoadReady: true,
      selected: null,
    }
  },

  computed: {
    store() {
      return store;
    },
    categoryIds() {
      console.log("this.$route.query.category_ids", this.$route.query.category_ids)
      return (this.$route.query.category_ids ? this.$route.query.category_ids.split(",") : [])
    }
  },

  apollo: {
    backgrounds: {
      query: BackgroundsQuery,
      variables: {
        page: 1,
        pageSize: 24,
        sortField: 'name',
        sortOrder: 'asc',
        search: '',
        categoryId: 0,
      },
    }
  },

  created () {
    this.reset()
  },

  watch: {
    '$route': 'reset'
  },

  methods: {
    reset() {
      this.page = 1;
      this.$apollo.queries.backgrounds.setVariables({
        page: 1,
        pageSize: 24,
        sortField: 'name',
        sortOrder: 'asc',
        search: '',
        categoryId: parseInt(this.categoryId),
      })
      this.$apollo.queries.backgrounds.refetch().then(() => {
        this.infiniteLoadReady = false
        this.$nextTick(() => {
          this.infiniteLoadReady = true
        })
      });
    },


    infiniteHandler($state) {
      if (this.page >= this.backgrounds.pagesCount) {
        $state.complete();
        return
      }
      this.page += 1
      let vm = this
      this.$apollo.queries.backgrounds.fetchMore({
        // New variables
        variables: {
          page: vm.page,
          pageSize: vm.pageSize,
          sortField: vm.sortField,
          sortOrder: vm.sortOrder,
          search: vm.search,
          categoryId: parseInt(vm.categoryId)
        },
        // Transform the previous result with new data
        updateQuery: (previousResult, { fetchMoreResult }) => {
          $state.loaded();

          return {
            backgrounds: {
              __typename: "BackgroundPage",
              entries: [...previousResult.backgrounds.entries, ...fetchMoreResult.backgrounds.entries],
              entriesCount: fetchMoreResult.backgrounds.entriesCount,
              pageSize: fetchMoreResult.backgrounds.pageSize,
              pagesCount: fetchMoreResult.backgrounds.pagesCount,
              currentPage: fetchMoreResult.backgrounds.currentPage,
            },
          }
        },
      })
    },
    toggle(background) {
      if (this.selected && this.selected.id == background.id) {
        this.selected = null
      } else {
        this.selected = background
      }
    },    
    async download() {
      if(this.selected) {
        let response = await axios.get(this.selected.url, { responseType: 'blob' })
        const image = {
          data: response.data,
          name: this.selected.filename,
        }
        parent.postMessage({'event': 'file-upload', 'file': image}, '*');      
      } 
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '../../styles/mixins';

  .actions {
    display: flex;
    justify-content: space-between;
    padding: 87px;
    @include bp(680px) {
      padding: 28px;
    }

    padding-bottom: 0px;
    border-bottom: 0px;

    // .picker {
    //   display:flex;
    //   align-items: center;
    //
    //   span {
    //     margin-right: 12px;
    //     font-size: 14px;
    //     font-family: var(--f-bold);
    //     color: black;
    //   }
    //   .icon {
    //     margin-left: 12px;
    //     padding-bottom: 35px;
    //     border-bottom: 2px solid #f7f8f9;
    //     cursor: pointer;
    //
    //     &.active {
    //       border-bottom: 2px solid #DFA9FF;
    //     }
    //   }
    // }

    .add {
      @include bp(680px) {
        display: none;
      }
    }

  }

  .backgrounds {
    margin-top: 20px;
    display: grid;
    justify-content: start;
    grid-column-gap: 16px;
    grid-row-gap: 50px;

    grid-template-columns: repeat( auto-fill, 300px );
  }

  .background {
    position: relative;
    width: 300px;
    min-height: 164px;

    &.not-selected:hover {

    }

    &:hover .delete {
      opacity: 1;
    }

    &__name {
      font-family: var(--f-semi);
        font-size: 11px;
        opacity: 0.4;
        margin-top: 13px;
    }

    img {
      cursor: pointer;
      opacity: 1;
      transition: opacity .3s;

    }

    &.selected {
      img {
        outline: 1px solid var(--text-pink);
        opacity: 1;
      }

      .delete {
        opacity: 0;
      }
    }

    &.not-selected {
      img {
        border: none;
        opacity: 0.5;
      }

      &:hover {
        img {
          opacity: 1;
        }
      }
    }

  }

  .download-bar-container {
    padding-left: 300px;
    @include bp(880px) {
      padding-left: 200px;
    }
    @include bp(680px) {
      padding-left: 0px;
    }
    position: fixed;
    bottom: 0;
    left: 0;
    right:0;
    transform: translateY(100%);
    transition: transform .4s;

    &.is-visible {
      transform: translateY(0);
    }

    .download-bar {
      width: 100%;
      background: #3256FF;
      padding: 17px 30px;
      color: white;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .items {
        font-family: var(--f-bold);
        font-size: 14px;
        margin-right: 20px;
      }

    }
  }


</style>
